import { mapCollection } from '../../utils/collection.utils';
import { parseNumber } from '../../utils/number.utils';
import { ToolSettingMode } from '../tool-setting-mode';
import { OperationModeBuilder } from './operation-mode.builder';

export class ToolSettingModeBuilder {
  static fromJson(json) {
    return (json)
      ? new ToolSettingMode(
        json.hash,
        OperationModeBuilder.fromJson(json.mode),
        json.modeName,
        parseNumber(json.vibration),
        parseNumber(json.power)
      )
      : null;
  }

  static fromList(list) {
    return mapCollection(ToolSettingModeBuilder.fromJson, list);
  }

}



// WEBPACK FOOTER //
// /var/www/borneo/prod/borneo_app/src/app/core/models/builders/tool-setting-mode.builder.ts